import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../classes/user.class';

type UserDisplayNameFormat = 'lastFirst' | 'firstLast';

/**
 * Formats a user's display name as "LastName, FirstName Insertion" (default) or "FirstName Insertion LastName" (if format is 'firstLast').
 * If the resulting display name is empty or only contains commas/spaces, it falls back to using the user's 'name' property.
 * How to use:
 * {{ user | userDisplayName }} // Default: "LastName, FirstName Insertion"
 * {{ user | userDisplayName:'firstLast' }} // "FirstName Insertion LastName"
 */
@Pipe({
    name: 'userDisplayName',
    standalone: false,
})
export class UserDisplayNamePipe implements PipeTransform {
    public transform(user: User | null | undefined, format: UserDisplayNameFormat = 'lastFirst'): string {
        if (!user) {
            return '';
        }

        const firstName = user.firstname?.trim() ?? '';
        const insertion = user.insertion?.trim() ?? '';
        const lastName = user.lastname?.trim() ?? '';

        const displayName =
            format === 'firstLast'
                ? [firstName, insertion, lastName].filter(Boolean).join(' ')
                : `${lastName}, ${[firstName, insertion].filter(Boolean).join(' ')}`.trim();

        return /[^,\s]/.test(displayName) ? displayName : (user.name?.trim() ?? '');
    }
}
